import { provideWidgetClass } from "scrivito"

export const SlideWidget = provideWidgetClass("SlideWidget", {
  onlyInside: "SliderWidget",
  attributes: {
    background: ["reference", { only: ["Image", "Video"] }],
    backgroundColor: [
      "enum",
      {
        values: ["transparent", "white", "primary", "secondary"]
      }
    ],
    content: "widgetlist"
  },
  extractTextAttributes: ["content"]
})

export type SlideWidgetInstance = InstanceType<typeof SlideWidget>
export function isSlideWidgetInstance(
  obj: unknown
): obj is SlideWidgetInstance {
  return obj instanceof SlideWidget
}
